/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const CLEAR_ALL_POI = '@@nzr/POI/CLEAR_ALL_POI'
export const CLEAR_POI_CATEGORY = '@@nzr/POI/CLEAR_POI_CATEGORY'
export const DONE_FETCHING_POI = '@@nzr/POI/DONE_FETCHING_POI'
export const RECEIVE_POI = '@@nzr/POI/RECEIVE_POI'
export const START_FETCHING_POI = '@@nzr/POI/START_FETCHING_POI'
